import { render, staticRenderFns } from "./PayeeInviteModal.vue?vue&type=template&id=b55c657c&scoped=true"
import script from "./PayeeInviteModal.vue?vue&type=script&lang=js"
export * from "./PayeeInviteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c657c",
  null
  
)

export default component.exports